import { useContext, useState, useEffect, FC } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AdequacyQueryShape } from "@app/projects/CountyProjectContainer";
import { FlyoutContext } from "@app/shared/Flyouts";
import { SpecialtyTypeEnum } from "@app/projects/enumerators";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESRadioButton } from "@app/shared/qes-standards/forms/RadioButton";
import { parseQuerystring } from "@app/shared/utility/parseQuerystring";
import { querystringify } from "@app/shared/utility/querystringify";

const SpecialtyFilter: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const actionMenuContext = useContext(FlyoutContext);

  const getInitialSelected = () => {
    const query = parseQuerystring(location.search) as AdequacyQueryShape;
    if (query.specialtyType === SpecialtyTypeEnum.Informational || query.specialtyType === SpecialtyTypeEnum.Required) {
      return query.specialtyType;
    }
    return SpecialtyTypeEnum.All;
  };

  const [selected, setSelected] = useState<SpecialtyTypeEnum>(getInitialSelected);

  useEffect(() => {
    const query = parseQuerystring(location.search) as AdequacyQueryShape;
    if (query.specialtyType === SpecialtyTypeEnum.Informational || query.specialtyType === SpecialtyTypeEnum.Required) {
      setSelected(query.specialtyType);
    } else {
      setSelected(SpecialtyTypeEnum.All);
    }
  }, [location.search]);

  const updateQuery = () => {
    let query = parseQuerystring(location.search) as AdequacyQueryShape;

    query = {
      ...query,
      specialtyType: selected,
    };

    const qs = querystringify(query as { [key: string]: unknown });
    history.push({
      ...history.location,
      search: qs,
    });
    actionMenuContext.handleCloseFlyout();
  };

  return (
    <>
      <div className="col-12 mb20 px-2">
        <QESRadioButton
          label="All Specialties"
          onChange={() => setSelected(SpecialtyTypeEnum.All)}
          checked={selected === SpecialtyTypeEnum.All}
          testId="all-specialties-filter"
          name="specialty-type"
        />
        <QESRadioButton
          label="Informational Specialties"
          onChange={() => setSelected(SpecialtyTypeEnum.Informational)}
          checked={selected === SpecialtyTypeEnum.Informational}
          testId="informational-specialties-filter"
          name="specialty-type"
        />
        <QESRadioButton
          label="Required Specialties"
          onChange={() => setSelected(SpecialtyTypeEnum.Required)}
          checked={selected === SpecialtyTypeEnum.Required}
          testId="required-specialties-filter"
          name="specialty-type"
        />
      </div>
      <div className="px-1">
        <QESButton qesType="primary" qesTestId="specialty-filter__apply" onClick={updateQuery} className="col-12">
          Apply
        </QESButton>
      </div>
    </>
  );
};

export default SpecialtyFilter;